import React from 'react';

// UAE Dirham Symbol Component
// الرمز الرسمي للدرهم الإماراتي

const DirhamIcon = ({ className = "w-4 h-4", style = {}, color = "white" }) => {
  const getFilter = () => {
    switch(color) {
      case 'primary':
      case 'gold':
      case 'yellow':
        // Gold/Primary color (like #D4AF37)
        return 'brightness(0) saturate(100%) invert(73%) sepia(51%) saturate(497%) hue-rotate(6deg) brightness(94%) contrast(88%)';
      case 'green':
        return 'brightness(0) saturate(100%) invert(48%) sepia(79%) saturate(2476%) hue-rotate(86deg) brightness(118%) contrast(119%)';
      case 'red':
        return 'brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(104%) contrast(97%)';
      case 'cyan':
      case 'teal':
        return 'brightness(0) saturate(100%) invert(70%) sepia(52%) saturate(5619%) hue-rotate(150deg) brightness(101%) contrast(101%)';
      case 'gray':
      case 'muted':
        return 'brightness(0) saturate(100%) invert(50%)';
      case 'white':
      default:
        return 'brightness(0) invert(1)';
    }
  };

  return (
    <img 
      src="/icons/dirham-transparent.png" 
      alt="درهم"
      className={className}
      style={{ 
        display: 'inline-block',
        verticalAlign: 'baseline',
        position: 'relative',
        top: '0.1em',
        filter: getFilter(),
        ...style 
      }}
    />
  );
};

// Colored version that inherits text color via CSS class detection
export const DirhamIconColored = ({ className = "w-4 h-4", colorClass = "", style = {}, color = "" }) => {
  const getFilterFromClass = () => {
    const cls = colorClass || color || className;
    
    // Primary/Gold colors
    if (cls.includes('primary') || cls.includes('gold') || cls.includes('yellow') || cls.includes('amber')) {
      return 'brightness(0) saturate(100%) invert(73%) sepia(51%) saturate(497%) hue-rotate(6deg) brightness(94%) contrast(88%)';
    }
    // Green colors
    if (cls.includes('green') || cls.includes('emerald')) {
      return 'brightness(0) saturate(100%) invert(48%) sepia(79%) saturate(2476%) hue-rotate(86deg) brightness(118%) contrast(119%)';
    }
    // Red colors
    if (cls.includes('red') || cls.includes('rose') || cls.includes('destructive')) {
      return 'brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(104%) contrast(97%)';
    }
    // Cyan/Teal colors
    if (cls.includes('cyan') || cls.includes('teal')) {
      return 'brightness(0) saturate(100%) invert(70%) sepia(52%) saturate(5619%) hue-rotate(150deg) brightness(101%) contrast(101%)';
    }
    // Blue colors
    if (cls.includes('blue')) {
      return 'brightness(0) saturate(100%) invert(37%) sepia(93%) saturate(7471%) hue-rotate(215deg) brightness(95%) contrast(93%)';
    }
    // Gray/Muted colors
    if (cls.includes('gray') || cls.includes('muted') || cls.includes('zinc') || cls.includes('slate')) {
      return 'brightness(0) saturate(100%) invert(50%)';
    }
    // Default white for dark backgrounds
    return 'brightness(0) invert(1)';
  };

  return (
    <img 
      src="/icons/dirham-transparent.png" 
      alt="درهم"
      className={className}
      style={{ 
        display: 'inline-block',
        verticalAlign: 'baseline',
        position: 'relative',
        top: '0.1em',
        filter: getFilterFromClass(),
        ...style 
      }}
    />
  );
};

// Text with Dirham symbol - use this to replace "100 د.إ" with "100 [icon]"
export const PriceWithDirham = ({ amount, className = "", iconSize = "w-4 h-4", color = "primary" }) => {
  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <span>{amount}</span>
      <DirhamIcon className={iconSize} color={color} />
    </span>
  );
};

export default DirhamIcon;
